import { get, isEmpty } from 'lodash'
import { filterOperators } from './filterOperators'

export function evaluateObjectFilter (obj, filter) {
  if (!filter || isEmpty(filter)) return true
  if ('$and' in filter) {
    return filter.$and.reduce((agg, item) => {
      return agg && evaluateObjectFilter(obj, item)
    }, true)
  }
  if ('$or' in filter) {
    return filter.$or.reduce((agg, item) => {
      return agg || evaluateObjectFilter(obj, item)
    }, false)
  }
  if ('$not' in filter) {
    return !evaluateObjectFilter(obj, filter.$not)
  }
  if ('$threshold' in filter) {
    // threshold filter determines if N number of filters passed
    return filter.$threshold.reduce((res, item) => {
      return res + (evaluateObjectFilter(obj, item) ? 1 : 0)
    }, 0) >= filter.$count
  }
  if ('$if' in filter) {
    const conditionResult = evaluateObjectFilter(obj, filter.$if)
    return evaluateObjectFilter(obj, conditionResult ? filter.$then : filter.$else)
  }
  if ('$return' in filter) {
    return !!filter.$return
  }
  if ('accessor' in filter) {
    const value = get(obj, filter.accessor.split('.'))
    return filterOperators[filter.op](value, filter.value)
  }

  return false
}
